export default {
  init() {
    (function fitIFrameToWindow($){
      var iframe = $('.calculator__iframe');
      var win = $(window);
      function fill() {
        var scale = Math.min(win.width()/826, 1);
        iframe.css({ transform: 'translateX(-50%) scale(' + scale + ')' });
      }
      fill();
      win.on('resize', fill);
    })(window.jQuery);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/calculator.js